// A szolgáltatás-részletező sorának SZÁMLA-FELIRATA — egy helyen, mert a kártya és az export is ezt mondja ki.
//
// A forrás a BFF `billing` mezője (a tény-oldali bizonylat-tételekből), NEM a terv `isDue`-ja: az egy utólag
// fizetett havidíjnál „ebben a hónapban nincs számla"-t írt a novemberben kelt, októberre szóló számla mellett
// (user-lelet). A sor a hónapjához TARTOZÓ bizonylatot mutatja, akármikor kelt.
import { type TFunction } from 'i18next';

import { formatMonthLabel } from '@/lib/month';

export type DetailBilling =
  | { state: 'invoiced'; invoices: { id: string; invoiceNumber: string | null }[] }
  | { state: 'expected'; month: string }
  | { state: 'missing' }
  | { state: 'none' };

/** A bizonylat megjelenített száma (a szám nélküli piszkozaté külön felirat). */
export function invoiceLabel(invoiceNumber: string | null, t: TFunction): string {
  return invoiceNumber ?? t('revenueForecast.details.billing.noNumber');
}

/** A számla-állapot egysoros szövege (export, és a link nélküli megjelenítés); `null` = nincs mit kimondani. */
export function billingText(billing: DetailBilling, t: TFunction, locale: string): string | null {
  switch (billing.state) {
    case 'invoiced':
      return `${t('revenueForecast.details.billing.invoiced')}: ${billing.invoices
        .map((i) => invoiceLabel(i.invoiceNumber, t))
        .join(', ')}`;
    case 'expected':
      return t('revenueForecast.details.billing.expected', {
        month: formatMonthLabel(billing.month, locale),
      });
    case 'missing':
      return t('revenueForecast.details.billing.missing');
    case 'none':
      return null;
  }
}
